module.exports = __webpack_public_path__ + "static/media/government.a04a5516.svg";